<template>
  <iColumn width="hug" gap="none">
    <iIcon
      v-if="metadataIconName"
      :icon="metadataIconName"
      :name="metadataIconName"
      :variant="getOptionValue(IconVariant)"
      :size="getOptionValue(IconSize)"
      :border-top="myBorderSides.top"
      :border-bottom="myBorderSides.bottom"
      :border-left="myBorderSides.left"
      :border-right="myBorderSides.right"
      disable-hover-effect
      :style-overrides="iconStyleOverrides"
    />
    <iIcon
      v-else-if="editMode || isPreviewMode"
      icon="image"
      :size="getOptionValue(IconSize)"
      disable-hover-effect
    />
  </iColumn>
</template>

<script>
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import IconVariant from "%/dynamic-component-editor/options/icon-variant";
import IconSize from "%/dynamic-component-editor/options/icon-size";
import IconColor from "%/dynamic-component-editor/options/icon-color";
import IconOptions from "%/dynamic-component-editor/bundles/icon-options";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import EffectsOptions from "%/dynamic-component-editor/bundles/effects-options";
import BorderOptions from "%/dynamic-component-editor/bundles/border-options";
import BorderSides from "%/dynamic-component-editor/options/border-sides";
import TextShadow from "%/dynamic-component-editor/options/text-shadow";
import BaseOption from "%/dynamic-component-editor/classes/base-option";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import LayoutHeight from "%/dynamic-component-editor/options/layout-height";

export default {
  name: "StoryMetadataIcon",
  mixins: [DynamicElementMixin],
  inject: {
    useExampleData: { default: () => () => false },
  },
  optionBundles: [
    AppearanceOptions,
    new IconOptions({}, {
      "icon": true,
    }),
    new EffectsOptions({}, {
      "box-shadow": true,
    }),
    BorderOptions,
  ],
  options: [
    new LayoutWidth({
      default: "hug",
    }, true),
    new LayoutHeight({
      default: "hug",
    }, true),
  ],
  data() {
    return {
      IconVariant,
      IconSize,
      BaseOption,
    };
  },
  computed: {
    isPreviewMode() {
      const fn = this.useExampleData;
      return typeof fn === "function" ? Boolean(fn()) : Boolean(fn);
    },
    metadataIconName() {
      return "";
    },
    myBorderSides() {
      return this.getOptionValue(BorderSides);
    },
    iconStyleOverrides() {
      const overrides = {
        textShadow: this.getOptionValue(TextShadow),
        textShadowHover: this.getOptionValue(TextShadow, BaseOption.$states.HOVER),
      };
      const variant = this.getOptionValue(IconVariant) || "primary";
      overrides[`${variant}VariantColor`] = this.getOptionValue(IconColor);
      return overrides;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
